<template>
  <v-container class="fill-height">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3">
        <v-card class="px-sm-1 px-0 withbg mx-auto shadowCard" max-width="600">
          <v-card-title primary-title>
            <v-spacer></v-spacer>
            <v-img src="@/assets/logo.png" max-width="250"></v-img>
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>

          	<div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
              Nombre completo
            </div>
            <v-text-field
              v-model="usuario.nombre_completo"
              label="nombre completo"
              filled
              dense
              required
              color="primary"
              single-line
              prepend-inner-icon="mdi-account"
              hide-details
              class="mb-2"
            ></v-text-field>

            <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
              Teléfono
            </div>
            <v-text-field
              v-model="usuario.telefono"
              label="81 1111 1111"
              filled
              dense
              required
              color="primary"
              single-line
              prepend-inner-icon="mdi-phone"
              hide-details
              class="mb-2"
            ></v-text-field>

            <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
              Fecha de nacimiento
            </div>
            <v-text-field
              v-model="usuario.fecha_nacimiento"
              label="usuario@fithouse.com"
              filled
              dense
              required
              color="primary"
              single-line
              prepend-inner-icon="mdi-calendar"
              type="date"
              hide-details
              class="mb-2"
            ></v-text-field>


            <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
              Usuario
            </div>
            <v-text-field
              v-model="usuario.correo"
              label="usuario@fithouse.com"
              filled
              dense
              required
              color="primary"
              single-line
              prepend-inner-icon="mdi-email-outline"
              hide-details
              class="mb-2"
            ></v-text-field>

            <div class="text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between">
              Contraseña
            </div>
            <v-text-field
              v-model="usuario.pass"
              label="*******"
              type="password"
              filled
              dense
              required
              color="primary"
              single-line
              :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              @keyup.enter="registrarme()"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-btn
              tile
              type="submit"
              block
              color="primary"
              class=" btn-login text-capitalize"
              @click="registrarme()"
            >
              Registrarme
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Dialog de carga -->
      <Alerta               v-if="respuestaAlerta"          :parametros="parametros"/>
      <carga                v-if="cargar"/>

    </v-row>
  </v-container>
</template>
<script>

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'


  export default {

    components:{
      Alerta,
      carga,
    },

    mixins: [validarErrores],

    data(){
      return{
        usuario:{
          nombre_completo:'',
          telefono:'',
          fecha_nacimiento:'',
          correo:'',
          pass:'',
        },
        showPassword: false,
      }
    },

    methods:{
      // Función para validar que los campos están llenos
      validate(){
        return !(!this.usuario.nombre_completo || !this.usuario.telefono || !this.usuario.fecha_nacimiento || !this.usuario.correo || !this.usuario.pass)
      },

      // función para registrar los datos del usuario
      registrarme(){
        // validar que se hayan llenado todos los datos del usuario
        if( this.validate() ){

          this.cargar = true
          // Lo mandapos por el EP
          this.$http.post('usuarios.add', this.usuario).then(response=>{
            this.$router.push({name: 'Login'})
            this.cargar = false
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        
        }else{
          this.validarErrorDirecto('Favor de llenar todos los campos')
        }
      }
    }
  }
</script>
<style>
  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 8px !important;
  }

  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 6px !important;
  }


  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: 0px !important;
    justify-content: flex-end;
  }

  .shadowCard{
    border-radius: 8px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
  }

  .text-muted{
    color: rgb(var(--v-theme-muted)) !important;
  }

  body {
    font-family: 'Plus Jakarta Sansa', sans-serif !important;
  }

  .shadowCard{
    border-radius: 8px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
  }

  .btn-login{
    background: rgb(255,19,19);
    background: linear-gradient(90deg, rgba(255,19,19,1) 21%, rgba(0,0,0,1) 77%);
  }
</style>